import React from 'react';
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { MaintenanceReportCategories } from '../MaintenanceReportCategories';
import { Layout } from '@singularsystems/neo-canvas-grid';
import { Neo } from '@singularsystems/neo-react';
import OpeningEntryIsSellReportCriteria from './OpeningEntryIsSellReportCriteria';
import { AppService, Types } from '../../../App/Services/AppService';
import { TextConstants } from '../../../Common/TextConstants';



@NeoReport("OpeningEntryIsSell",  { category: MaintenanceReportCategories.DataValidationReports})
export default class OpeningEntryIsSellReport extends Report<OpeningEntryIsSellReportCriteria>{

    constructor(
        public serviceProviderApiClient = AppService.get(Types.ApiClients.ServiceProviderApiClient),
    ) {
        super(OpeningEntryIsSellReportCriteria);
    }

    public renderCriteria() {
        return (
        <>
            <Neo.GridLayout lg={3} md={3}>
                <Neo.FormGroup bindContext={this.criteria.meta.staticServiceProviderFileGroupingId} label={TextConstants.Labels.Broker}>
                    <Neo.AutoCompleteDropDown
                        itemSource={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria}
                        bind={this.criteria.meta.staticServiceProviderFileGroupingId}
                        bindDisplay={this.criteria.meta.staticServiceProviderFileGroupingName}
                        displayMember={"serviceProviderGroupingName"}
                        items={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria(" ").then((arr) => arr.data.slice(0,10)
                        .sort((x,y) => x.serviceProviderGroupingName.localeCompare(y.serviceProviderGroupingName)))}
                        />
                </Neo.FormGroup>
            </Neo.GridLayout>
        </>
        );
    }

    public getDefaultGridLayout() {
        return {
            "root": {
            }
        } as Layout.IGridLayout;
    }
}